import { useQuery } from '@tanstack/react-query';
import { authApi } from '../api/auth';

export const AUTH_STATUS_KEY = ['auth', 'status'] as const;

/** 잠금/로그인 상태 — RequireAuth와 TopBar가 구독한다.
 *
 * refetchOnMount: 'always' — 마운트 시 캐시 유무와 관계없이 항상 fresh fetch.
 *   이유: hard reload 없이 컴포넌트가 재마운트될 때 stale 캐시로 인한 stuck 방지.
 * retry/retryDelay — 일시적 네트워크 장애 시 지수 백오프 재시도.
 */
export function useAuthStatus() {
  return useQuery({
    queryKey: AUTH_STATUS_KEY,
    queryFn: () => authApi.status(),
    staleTime: 5_000,
    refetchOnMount: 'always',       // 마운트 시 무조건 fetch (stale 캐시 무시)
    refetchOnWindowFocus: true,     // 탭 복귀 시 refetch
    refetchOnReconnect: true,       // 네트워크 복구 시 refetch
    retry: 2,                       // 실패 시 최대 2회 재시도
    retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 5000),  // 1s → 2s → 5s 상한
  });
}
